module.exports = __webpack_public_path__ + "static/media/roberta.b9550882.bin";